export default {
	'add-new-product': '',
	'the-product': '',
	product: '',
	confirm: '',
	'are-you-sure-you-want-to-$-this-product': '',
	activate: '',
	deactivate: '',
}